export default [
  {
    path: '/admin/product-assemblies',
    name: 'product-assembly',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/assembly')
  },
]